import type { SafeZoneSpec } from '../../data/safe-zones';
import { getSafeRect, OVERLAY_STYLE } from './safeZoneOverlay';

interface Props {
  spec: SafeZoneSpec;
  className?: string;
  /** Accessible title; omit when the SVG sits on top of media as decoration. */
  title?: string;
}

/** Data-built overlay in canvas coordinates (`viewBox="0 0 W H"`), scaled by CSS. */
export function SafeZoneOverlaySvg({ spec, className, title }: Props) {
  const { width: W, height: H } = spec.canvas;
  const safe = getSafeRect(spec);
  const stroke = Math.max(2, Math.round(W / 360));
  const fontSize = Math.round(W / 40);

  return (
    <svg
      viewBox={`0 0 ${W} ${H}`}
      className={className}
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      preserveAspectRatio="xMidYMid meet"
    >
      {title ? <title>{title}</title> : null}
      <path
        fillRule="evenodd"
        fill={OVERLAY_STYLE.marginFill}
        d={`M0 0H${W}V${H}H0Z M${safe.x} ${safe.y}V${safe.y + safe.height}H${safe.x + safe.width}V${safe.y}Z`}
      />
      <rect
        x={safe.x}
        y={safe.y}
        width={safe.width}
        height={safe.height}
        fill="none"
        stroke={OVERLAY_STYLE.safeStroke}
        strokeWidth={stroke}
      />
      {spec.uiElements.map((rect) => (
        <g key={`${rect.label}-${rect.x}-${rect.y}`}>
          <rect
            x={rect.x}
            y={rect.y}
            width={rect.width}
            height={rect.height}
            fill="none"
            stroke={OVERLAY_STYLE.uiStroke}
            strokeWidth={stroke}
            strokeDasharray={`${stroke * 4} ${stroke * 3}`}
          />
          {rect.label ? (
            <text
              x={rect.x + stroke * 4}
              y={rect.y + stroke * 4 + fontSize}
              fill={OVERLAY_STYLE.labelFill}
              fontSize={fontSize}
              fontWeight={600}
              fontFamily="system-ui, sans-serif"
            >
              {rect.label}
            </text>
          ) : null}
        </g>
      ))}
    </svg>
  );
}
